import { useState } from "react";
import { InputForm } from "../atoms/input";
import { PackageComp } from "./packageComp";
import { VerticalLayout } from "./layout";
import { SettingHeader } from "../molecule/SettingHeader";
import { SettingsHeader } from "../molecule/settingsHeader";

export function BillingSettingComp() {
    const [packageActive,setPackageActive] = useState(1)
    const clickPackage = (pack) => {
            setPackageActive(pack)

    }
    const PACKAGE1 = 1
    const PACKAGE2 = 2
    const PACKAGE3 = 3
    return (
        <VerticalLayout>
                <SettingsHeader 
                        
                        title="Betalingen" 
                        description="Bekijk hier je pakketten en facturen" 
                      />
            <h6 className="standard-margin-left standard-margin-top regular-bold" style={{ marginBottom: '0.5rem' }}>Jouw pakketten</h6>
            <div className="horizontal">
                <PackageComp
                    onClick={() => clickPackage(PACKAGE1)}
                    active={(packageActive == PACKAGE1)}
                    packageData={{ Package: "Basic", Price: "9.99", CourseCount: 10, EmployeeCount: 5, Support: "Basic support" }}
                />
                <PackageComp
                    onClick={() => clickPackage(PACKAGE2)}
                    active={(packageActive == PACKAGE2)}
                    packageData={{ Package: "Premium", Price: "29.99", CourseCount: 20, EmployeeCount: 10, Support: "Premium support" }}
                />
                <PackageComp
                    onClick={() => clickPackage(PACKAGE3)}
                     active={(packageActive == PACKAGE3)}
                    packageData={{ Package: "Enterprise", Price: "39.99", CourseCount: 50, EmployeeCount: 45, Support: "Enterprise support" }}
                />
            </div>
            <div className="grey-background-100 standard-margin" style={{ height: "1px" }} ></div>
            <h6 className="standard-margin-left standard-margin-top regular-bold" style={{ marginBottom: '0.5rem' }}>Betaalwijze</h6>
            <div className="vertical standard-margin" style={{ width: "30%" }}>
                <InputForm
                    title={"Naam"}
                    placeholder={"Naam"}
                />
                <InputForm
                    title={"Creditcard nummer"}
                    placeholder={"creditcard"}
                    typeInput={"number"}
                />
                <div className="horizontal" style={{ "width": "unset" }}>
                    <InputForm title={"Verval datum"} />
                    <InputForm title={"cvc"} />
                </div>
            </div>

            <div className="grey-background-100 standard-margin" style={{ height: "1px" }} ></div>

            <h6 className="standard-margin-left standard-margin-top regular-bold" style={{ marginBottom: '0.5rem' }}>Facturen</h6>
        </VerticalLayout>
    )
}